<template>
  <transition name="modal-fade">
    <div
      v-if="show"
      :class="modalClassName"
      transition="modal"
      @click="onBackDropClick"
    >
      <div :class="modalContainerClassName" @click.stop>
        <slot name="header" :close="close" />
        <div class="modal-body">
          <slot />
        </div>
        <div class="modal-footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    closeOnBackdropClick: {
      type: Boolean,
      default: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      required: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    modalType: {
      type: String,
      default: 'centered',
    },
    size: {
      type: String,
      default: '',
    },
    customClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localShow: this.show,
    };
  },
  watch: {
    show(val) {
      this.localShow = val;
    },
    localShow(val) {
      if (!val) {
        this.$emit('update:show', false);
        this.$emit('close');
      }
    },
  },
  computed: {
    modalContainerClassName() {
      let isSafari = this.isSafari() ? 'is-safari' : '';
      let className = `modal-container ${this.customClasses}`;
      if (this.fullWidth) {
        return `${className} modal-container--full-width ${isSafari}`;
      }

      return `${className} ${this.size} ${isSafari}`;
    },
    modalClassName() {
      const modalClassNameMap = {
        centered: '',
        'right-aligned': 'right-aligned',
      };

      return `modal-mask ${modalClassNameMap[this.modalType] || ''}`;
    },
  },
  mounted() {
    // guardamos el handler para poder removerlo al destruir
    this.onKeydownHandler = e => {
      if (this.show && e.code === 'Escape') {
        this.close();
      }
    };
    document.addEventListener('keydown', this.onKeydownHandler);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydownHandler);
  },
  provide() {
    // Exponemos una función de cierre para que componentes hijos (ej. ModalHeader)
    // puedan inyectarla en lugar de depender de pasar :close por todos los usos.
    return {
      modalClose: () => this.close(),
    };
  },
  methods: {
    close() {
      // llamamos la función pasada por prop si existe
      if (typeof this.onClose === 'function') {
        this.onClose();
      }
      this.localShow = false;
    },
    onBackDropClick() {
      if (this.closeOnBackdropClick) {
        this.close();
      }
    },
    /**
     * Obtiene el userAgent utilizado
     */
    agentHas(keyword) {
      return (
        navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1
      );
    },
    /**
     * Determina si es safari el navegador
     */
    isSafari() {
      return (
        (!!window.ApplePaySetupFeature || !!window.safari) &&
        this.agentHas('Safari') &&
        !this.agentHas('Chrome') &&
        !this.agentHas('CriOS')
      );
    },
  },
};
</script>

<style scoped lang="scss">
.modal-container--full-width {
  align-items: center;
  border-radius: 0;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.modal-mask.right-aligned {
  justify-content: flex-end;

  .modal-container {
    width: 48rem;
  }
}
.modal-big {
  width: 60%;
}

.modal-medium {
  width: 40%;
}

.is-safari {
  z-index: unset;
}
</style>
